"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _loveButton = _interopRequireDefault(require("./loveButton.js"));

var _fullscreenSocialDownload = _interopRequireDefault(require("./fullscreenSocialDownload.js"));

var _utils = require("../utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash"));

var _shareStore = _interopRequireDefault(require("-!svg-react-loader!../assets/images/fullscreen-store/share-store.svg"));

var _fullscreenEvents = _interopRequireDefault(require("../constants/fullscreenEvents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenMobileBar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenMobileBar, _React$Component);

  function FullscreenMobileBar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      showShare: false
    };
    _this.sampleInput = {
      love: {
        onClick: function onClick() {},
        text: '1'
      }
    };
    return _this;
  }

  var _proto = FullscreenMobileBar.prototype;

  _proto.getLoveButton = function getLoveButton() {
    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        love = _this$props.love;

    var props = _lodash["default"].pick(this.props, ['itemId', 'id', 'item', 'idx', 'styleParams', 'love', 'hashtag', 'actions']);

    return styleParams.loveButton ? _react["default"].createElement(_loveButton["default"], _extends({}, props, {
      type: this.props.current.item.type,
      layout: "fullscreen",
      device: "mobile",
      showCounter: true,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    }, this.props.current.itemLoveData)) : '';
  };

  _proto.getDownloadButton = function getDownloadButton() {
    var _this$props2 = this.props,
        current = _this$props2.current,
        styleParams = _this$props2.styleParams,
        additionalNavbarElement = _this$props2.additionalNavbarElement;
    var hasAdditionalNavbarElement = typeof additionalNavbarElement === 'function';
    return _react["default"].createElement(_fullscreenSocialDownload["default"], {
      layout: "fullscreen",
      device: "mobile",
      hasAdditionalNavbarElement: hasAdditionalNavbarElement,
      current: current,
      styleParams: styleParams,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    });
  };

  _proto.getAdditionalNavbarElement = function getAdditionalNavbarElement() {
    var additionalNavbarElement = this.props.additionalNavbarElement;

    try {
      if (additionalNavbarElement) {
        return additionalNavbarElement(this.props);
      } else {
        return false;
      }
    } catch (e) {
      console.error('Could not get additional navbar element', e);
    }
  };

  _proto.getShareContainer = function getShareContainer() {
    var _this2 = this;

    var shareButton = this.props.styleParams.allowSocial ? _react["default"].createElement("button", {
      className: "pro-fullscreen-share-icon",
      onClick: function onClick() {
        return _this2.props.actions.toggleShareScreen();
      }
    }, (0, _shareStore["default"])()) : // <i className='progallery-svg-font-icons-share-store pro-fullscreen-share-icon' onClick={() => this.props.actions.toggleShareScreen()}/>
    false;
    return _react["default"].createElement("div", {
      className: "fullscreen-social"
    }, this.getDownloadButton(), this.getAdditionalNavbarElement(), this.getLoveButton(), shareButton);
  };

  _proto.getTopMobileBar = function getTopMobileBar() {
    var _this3 = this;

    var mobileTopClassNames = (0, _classnames["default"])('fullscreen-mobile-bar', 'fullscreen-mobile-top', 'pro-fullscreen-store', 'fixed-items', {
      share: this.state.showShare
    });
    return _react["default"].createElement("div", {
      className: mobileTopClassNames
    }, _react["default"].createElement("div", null, _react["default"].createElement("button", {
      className: "fullscreen-close progallery-svg-font-icons-back",
      onClick: function onClick() {
        var eventData = {
          itemIdx: _this3.props.current.idx
        };

        _this3.props.actions.eventsListener(_fullscreenEvents["default"].CLOSE_FULLSCREEN, eventData);
      }
    }), this.getShareContainer()));
  };

  _proto.render = function render() {
    var mobileBars = [];

    if (_utils.utils.isSmallScreen()) {
      mobileBars[0] = this.getTopMobileBar();
      mobileBars[1] = false;
    }

    var res = this.props.isFirst ? mobileBars[0] || false : mobileBars[1] || false;
    return res;
  };

  return FullscreenMobileBar;
}(_react["default"].Component);

var _default = FullscreenMobileBar;
exports["default"] = _default;